export const URL_API = "https://pro.agendaimmo.com";
export const CDN_URL = "https://cdn.jsdelivr.net/gh/agenda-immo/minisdk@main/";